import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import './QuickPick.css';
import './HomePage.css';


const QuickPickElimination = () => {
    const [media, setMedia] = useState({ movies: [], 'tv-shows': [] });
    const hasInitializedRef = React.useRef(false);
    const [currentList, setCurrentList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedMediaType, setSelectedMediaType] = useState(null);
    const [pointsMap, setPointsMap] = useState({});
    const [voteHistory, setVoteHistory] = useState([]);
    const [highlightTrigger, setHighlightTrigger] = useState(false);
    const [sortMode, setSortMode] = useState('alphabetical'); // 'alphabetical' | 'rating' | 'top-picks' | 'recent'
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
      const checkMobile = () => setIsMobile(window.innerWidth <= 768);
      checkMobile();
      window.addEventListener('resize', checkMobile);
      return () => window.removeEventListener('resize', checkMobile);
    }, []);
    const username = Cookies.get("username") || 'default';
    const location = useLocation();
    const navigate = useNavigate();

    const handleDeleteItemQuickPick = (docId, fromLibrary, username, setLibrary, setWatchList) => {
      if (window.confirm("Are you sure you want to delete this item?")) {
        fetch(`/w/${username}/delete/${docId}`, { method: 'GET' })
          .then(response => response.json())
          .then(data => console.log('Deleted:', data))
          .catch(error => console.error('Error deleting item:', error));

        if (fromLibrary) {
          setLibrary(prev => prev.filter(item => item.id !== docId));
        } else {
          setWatchList(prev => prev.filter(item => item.id !== docId));
        }
      }
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const mediaType = searchParams.get('m');
        if (mediaType === 'tv-shows' || mediaType === 'movies') {
            setSelectedMediaType(prev => {
                if (prev !== mediaType) {
                    setCurrentList([]);
                    setVoteHistory([]);
                    setPointsMap({});
                }
                return mediaType;
            });
        }

        if (mediaType) {
          fetch(`/api/watchlist/${username}`)
              .then(response => response.json())
              .then(data => {
                  const rawList = data[mediaType]?.map(item => ({ ...item[1], id: item[0] })) || [];
                  const topItems = JSON.parse(localStorage.getItem(`sortedWatchList-${mediaType}`)) || [];

                  // Properly update media list for the current mediaType, preserving other types
                  setMedia(prev => ({
                      ...prev,
                      [mediaType]: rawList
                  }));

                  // Restore selection state and vote history from localStorage
                  const initialPoints = {};
                  topItems.forEach(item => {
                    initialPoints[item.tmdb_id] = 1;
                  });
                  setPointsMap(initialPoints);
                  setVoteHistory(topItems.map(item => item.tmdb_id));
                  setCurrentList(topItems);
                  setIsLoading(false);
              })
              .catch(error => {
                  console.error('Error fetching watchlist:', error);
                  setIsLoading(false);
              });
        }
    }, [location.search, username]);



    useEffect(() => {
        if (!hasInitializedRef.current && selectedMediaType && media[selectedMediaType]?.length > 0) {
            hasInitializedRef.current = true;
            // do not clear existing data
        }
    }, [selectedMediaType, media]);

    const handleCardClick = (item) => {
        const id = item.tmdb_id;
        const currentPoints = pointsMap[id] || 0;

        const updatedPointsMap = { ...pointsMap };
        const topList = selectedMediaType ? JSON.parse(localStorage.getItem(`sortedWatchList-${selectedMediaType}`)) || [] : [];
        const isAlreadySelected = updatedPointsMap[id] > 0;
        // Removed restriction: allow unlimited top picks
        if (isAlreadySelected) {
            updatedPointsMap[id] = 0;
        } else {
            updatedPointsMap[id] = 1;
        }

        setPointsMap(updatedPointsMap);
        setVoteHistory(prev => [...prev, id]);

        // Instead of replacing, add/remove this item to the top picks
        let updatedTopList = [...topList];
        if (isAlreadySelected) {
            // Remove from top picks
            updatedTopList = updatedTopList.filter(i => i.tmdb_id !== id);
        } else {
            // Add to top picks
            updatedTopList.push(item);
        }

        localStorage.setItem('sortedWatchList', JSON.stringify(updatedTopList));
        localStorage.setItem(`sortedWatchList-${selectedMediaType}`, JSON.stringify(updatedTopList));

        setHighlightTrigger(true);
        setTimeout(() => setHighlightTrigger(false), 600);
    };

    const handleUndo = () => {
        if (voteHistory.length === 0) return;
        const lastId = voteHistory[voteHistory.length - 1];
        setPointsMap(prev => {
            const newPoints = { ...prev };
            if (newPoints[lastId] > 1) newPoints[lastId] -= 1;
            else delete newPoints[lastId];
            return newPoints;
        });
        setVoteHistory(prev => prev.slice(0, -1));
    };

    const handleReset = () => {
        setPointsMap({});
        setVoteHistory([]);
        // Also clear localStorage for this session
        localStorage.removeItem('sortedWatchList');
        if (selectedMediaType) {
            localStorage.removeItem(`sortedWatchList-${selectedMediaType}`);
        }
    };

    const saveToLocalStorage = (finalList) => {
        localStorage.setItem('sortedWatchList', JSON.stringify(finalList));
        localStorage.setItem(`sortedWatchList-${selectedMediaType}`, JSON.stringify(finalList));
    };

    const handleDone = () => {
      if (selectedMediaType === 'movies') {
        window.location.href = '/?section=movies';
      } else if (selectedMediaType === 'tv-shows') {
        window.location.href = '/?section=tv';
      }
    };

    const topList = selectedMediaType ? JSON.parse(localStorage.getItem(`sortedWatchList-${selectedMediaType}`)) || [] : [];

    return (
        <div className="quick-pick-elimination-container">
            <div className="media-toggle-bar" style={{ display: 'flex', paddingTop:"40px",  justifyContent: 'space-between', alignItems: 'center', marginRight: '20px', marginLeft: '20px' }}>
                <div className="media-toggle">
                  <button
                    onClick={() => navigate('?m=tv-shows')}
                    className={`media-toggle-button ${selectedMediaType === 'tv-shows' ? 'active' : ''}`}
                  >
                    TV
                  </button>
                  <button
                    onClick={() => navigate('?m=movies')}
                    className={`media-toggle-button ${selectedMediaType === 'movies' ? 'active' : ''}`}
                  >
                    Movies
                  </button>
                </div>
                <div className="discover-group" style={{ display: 'flex', gap: '10px' }}>
                  <a
                    className="discover-btn active"
                    href={`/home?section=${selectedMediaType === 'tv-shows' ? 'tv' : 'movies'}`}
                  >Top Picks</a>
                  
                  <a href={`/quick-pick-elimination?m=${selectedMediaType}`} style={{
              backgroundColor: '#444',
              color: '#ccc',
              cursor: 'default'
            }} className="discover-btn">Watch list</a>
                  
                </div>
            </div>
            {isLoading ? (
                <p>Loading...</p>
            ) : (
                <>
                    <div style={{ padding: "20px", fontSize: "16px", color: "#ccc" }}>
                      {/* Instructional message removed from here */}
                    </div>
                    {selectedMediaType && (
                        <>
                            <div style={{
                              textAlign: 'center',
                              backgroundColor: 'rgba(13, 110, 253, 0.1)',
                              color: '#0d6efd',
                              fontSize: '1rem',
                              padding: '10px 16px',
                              margin: '10px auto',
                              borderRadius: '8px',
                              maxWidth: '500px'
                            }}>
                              <>✅ You’ve selected <strong>{topList.length}</strong> Top Pick{topList.length !== 1 ? 's' : ''} — click <strong style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={handleDone}>Done</strong> to continue!</>
                            </div>
                            <h2 style={{   }}>🎯 Your Top Picks</h2>
                            <div
                              className="grid-container-scroll"
                              style={{
                                marginBottom: "10px",
                                minHeight: "250px",
                                position: 'relative'
                              }}
                            >
                              {topList.length === 0 ? (
                                <div style={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  textAlign: 'center',
                                  backgroundColor: 'rgba(255,255,255,0.05)',
                                  color: '#eee',
                                  padding: '20px',
                                  borderRadius: '12px',
                                  fontSize: '1.15rem',
                                  maxWidth: '600px',
                                  lineHeight: '1.6',
                                  boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
                                }}>
                                  💡 You haven’t selected any top picks yet.<br />
                                  Click on posters below to add your favorites to <strong>Watch Now</strong>.
                                </div>
                              ) : (
                                [...topList].map(item => (
                                  <div
                                    key={item.tmdb_id}
                                    className="grid-item selected"
                                    onClick={() => handleCardClick(item)}
                                    style={{ cursor: 'pointer', position: 'relative', transition: 'opacity 0.5s ease' }}
                                  >
                                    <div className="vote-badge visible">
                                      <i className="fa fa-check" aria-hidden="true"></i>
                                    </div>
                                    <img
                                      src={item.full_poster_path}
                                      alt={item.title}
                                      style={{ width: '100%', borderRadius: '10px' }}
                                    />
                                  </div>
                                ))
                              )}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px 0' }}>
                              <h2 style={{ padding: "10px 0", margin: 0 }}>📚 Everything Else</h2>
                              <div style={{ textAlign: "right" }}>
                                {isMobile ? (
                                  <div className="mobile-sort-option">
                                    <button
                                      className="btn btn-sm btn-outline-light"
                                      onClick={() =>
                                        setSortMode(prev =>
                                          prev === 'alphabetical'
                                            ? 'rating'
                                            : prev === 'rating'
                                            ? 'top-picks'
                                            : prev === 'top-picks'
                                            ? 'recent'
                                            : 'alphabetical'
                                        )
                                      }
                                    >
                                      {sortMode === 'alphabetical'
                                        ? 'A → Z'
                                        : sortMode === 'rating'
                                        ? '★ Rating'
                                        : sortMode === 'top-picks'
                                        ? '🏆 Top Picks'
                                        : '🕒 Recently Added'}
                                    </button>
                                  </div>
                                ) : (
                                  <div className="desktop-sort-options" style={{ display: 'flex', gap: '10px' }}>
                                    {['alphabetical', 'rating', 'top-picks', 'recent'].map(mode => (
                                      <button
                                        key={mode}
                                        className={`btn btn-sm ${sortMode === mode ? 'btn-primary' : 'btn-outline-light'}`}
                                        onClick={() => setSortMode(mode)}
                                      >
                                        {mode === 'alphabetical' && 'A → Z'}
                                        {mode === 'rating' && '★ Rating'}
                                        {mode === 'top-picks' && '🏆 Top Picks'}
                                        {mode === 'recent' && '🕒 Recently Added'}
                                      </button>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="grid-container" style={{ marginBottom: "40px" }}>
                                {Array.isArray(media[selectedMediaType]) &&
                                  [...media[selectedMediaType]].sort((a, b) => {
                                    if (sortMode === 'top-picks') {
                                      const aSelected = pointsMap[a.tmdb_id] > 0 ? 1 : 0;
                                      const bSelected = pointsMap[b.tmdb_id] > 0 ? 1 : 0;
                                      if (aSelected !== bSelected) {
                                        return bSelected - aSelected;
                                      }
                                      return (a.title || '').localeCompare(b.title || '');
                                    }
                                    if (sortMode === 'rating') {
                                      return (b.vote_average || 0) - (a.vote_average || 0);
                                    }
                                    if (sortMode === 'recent') {
                                      return new Date(b.Created || 0) - new Date(a.Created || 0);
                                    }
                                    // alphabetical
                                    return (a.title || '').localeCompare(b.title || '');
                                  }).map(item => (
                                      <div
                                          key={item.tmdb_id}
                                          className={`grid-item ${pointsMap[item.tmdb_id] > 0 ? 'selected' : ''}`}
                                          onClick={() => handleCardClick(item)}
                                          style={{ cursor: 'pointer', position: 'relative', transition: 'opacity 0.5s ease' }}
                                      >
                                          <div
                                            className="remove-badge-quick-pick"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleDeleteItemQuickPick(item.id, true, username, setMediaList => {
                                                setMedia(prev => ({
                                                  ...prev,
                                                  [selectedMediaType]: prev[selectedMediaType].filter(i => i.id !== item.id)
                                                }));
                                              }, () => {});
                                            }}
                                            title="Remove from watchlist"
                                            style={{
                                              color: 'red',
                                              fontWeight: 'bold',
                                              fontSize: '44px',
                                              position: 'absolute',
                                              top: '-15px',
                                              left: '0px',
                                              zIndex: 2,
                                              cursor: 'pointer'
                                            }}
                                          >
                                            ×
                                          </div>
                                          <div className={`vote-badge ${pointsMap[item.tmdb_id] > 0 ? 'visible' : 'hidden'}`}>
                                            <i className="fa fa-check" aria-hidden="true"></i>
                                          </div>
                                          <img
                                              src={item.full_poster_path}
                                              alt={item.title}
                                              style={{ width: '100%', borderRadius: '10px' }}
                                          />
                                      </div>
                                  ))
                                }
                            </div>
                        </>
                    )}
                    <div className="sticky-control-bar" style={{
                        position: 'sticky',
                        bottom: 0,
                        background: 'rgba(0,0,0,0.7)',
                        padding: '10px',
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        zIndex: 1000
                    }}>
                        <button
                            className="btn btn-secondary"
                            onClick={handleUndo}
                            disabled={voteHistory.length === 0}
                        >
                            Undo
                        </button>
                        <button
                            className="btn btn-warning"
                            onClick={handleReset}
                            disabled={voteHistory.length === 0}
                        >
                            Reset
                        </button>
                        <button
                          className={`btn ${topList.length > 0 && highlightTrigger ? 'animate-highlight' : ''}`}
                          style={{
                            backgroundColor: topList.length > 0 ? '#198754' : '#6c757d',
                            color: 'white',
                            cursor: topList.length > 0 ? 'pointer' : 'not-allowed'
                          }}
                          onClick={handleDone}
                          disabled={topList.length === 0}
                        >
                          Done
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default QuickPickElimination;
